import React from "react";
import BigBibleChallenge from "../../containers/BigBibleChallenge/BigBibleChallenge";
import { Helmet } from "react-helmet";

const BigBible = () => {
  return (
    <>
      <Helmet>
        <title>Big Bible - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <BigBibleChallenge />
    </>
  );
};

export default BigBible;
